<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yIlzBh/tc-custom/9781534440180.jpg?1730491661805" alt="This image is the cover for the book Mindy Kim, Class President"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mindy Kim, Class President
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Fresh Off the Boat </i>meets Junie B. Jones in the adorable chapter book series following Mindy Kim, a young Asian American Girl—in this fourth novel, Mindy runs for class president!</b><br/><br/>It’s time to pick a class president, and Mindy really wants to win—and she’s basing her entire campaign on snacks and being kind, so how could she NOT be chosen?<br/><br/>But there is one big thing that Mindy is not sure she can do—make a speech to her class about why she would be the best pick for president. Can Mindy face her fears and show the class—and herself—that she can be the best class president ever?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lyla Lee, Dung Ho
      </h2>
      
      <p class="authorDescription body article">Lyla Lee is the bestselling author of young adult novels like&#160;<I>I&rsquo;ll Be the One</I>&#160;and&#160;<I>Flip the Script</I>. She also writes&#160;the Mindy Kim series&#160;for younger readers and the&#160;Gigi Shin books&#160;for the middle school crowd. Her books have been translated into multiple languages around the world. Born in South Korea, she&rsquo;s since then lived in various cities throughout the United States. Inspired by her English teacher, she started writing her own stories in fourth grade and finished her first novel at the age of fourteen. After working various jobs in Hollywood and studying Psychology and Cinematic Arts at the University of Southern California, she now lives in Dallas, Texas. Visit Lyla at&#160;LylaLeeBooks.com&#160;or on social media (Instagram, X (previously known as Twitter), and TikTok&#160;@LiteraryLyla).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?283b0f73